export const SUMMARY_CARDS = (data) => {

  return (
    [
      {
        key: 'participants',
        icon: "SVG-userprofile-tick",
        theme: 'neutral',
        label: 'Participants',
        value: data.participants && data.participants.total != undefined ? data.participants.total : "",
        description: 'unique leaders whose 360 was conducted',
      },
      {
        key: 'stakeholders',
        icon: "SVG-peoples",
        theme: 'teal',
        label: 'Stakeholders',
        value: data.stakeholders && data.stakeholders.total != undefined ? data.stakeholders.total : "",
        description: `raters excluding self · ${data.stakeholders && data.stakeholders.perParticipant} per participant`,
      },
      {
        key: 'categoriesFavorable',
        icon: "SVG-Verified-tick",
        theme: 'teal',
        label: '% Categories Favorable',
        value: `${data.categoriesFavorable && data.categoriesFavorable.pctCategoriesFavorable != undefined ? Math.trunc(data.categoriesFavorable.pctCategoriesFavorable) : ""}%`,
        description: 'mean ≥ 4 of 6',
      },
      {
        key: 'commentsLeft',
        icon: "SVG-Comments-content",
        theme: 'orange',
        label: 'Comments Left',
        value: `${data.comments && data.comments.strengthsCoveragePct != undefined ? Math.trunc(data.comments.strengthsCoveragePct) : "0"}% · ${data.comments && data.comments.developmentCoveragePct != undefined ? Math.trunc(data.comments.developmentCoveragePct) : "0"}%`,
        description: 'strengths · development areas',
      },
    ]
  );

} 

export const SUMMARY_NOTE =
  '1 of 6 categories sit below the favorable threshold and warrant a focused development conversation.';
